import { SvgIcon, SvgIconProps } from '@mui/material';

/** Barcode (product catalog nav). */
export const Tag = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M3 4.5V19.5M21 4.5V19.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7.5 4.5V16.5M12 4.5V16.5M16.5 4.5V16.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12 19.2V20.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M6.15 20H8.85M15.15 20H17.85"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </SvgIcon>
);
